function o(n, r) {
  const e = {};
  return n && r.forEach(
    (t) => e[t] = void 0
  ), e;
}
export {
  o as disableEventHandlers
};
